const path = require('path')

export const EXE_PATH = path.join(process.cwd(), 'resources', 'executable-files')
export const DECOMPOSITION_EXE_PATH = path.join(EXE_PATH, 'decomposition')
export const CORRELATION_EXE_PATH = path.join(EXE_PATH, 'correlation')
export const FFMPEG_EXE_PATH = path.join(EXE_PATH, 'ffmpeg')

export const SAMPLE_DATASOURCES_DIRECTORY = path.join(EXE_PATH, 'resources', 'sample-datasources')
export const LOGS_PATH = path.join(EXE_PATH, 'resources','logs', 'log.log')